import { inject, Injectable } from '@angular/core';
import { DefaultConfigLoader } from '../engine/config/default-config-loader';
import { AuthorizationService } from './authorization.service';

@Injectable()
export class AuthConfigLoader extends DefaultConfigLoader {
  private readonly auth = inject(AuthorizationService);

  protected override initTranslation(): void {
    this.auth.init();
    super.initTranslation();
  }
}
